import { NgModule } from '@angular/core';
import { Routes, RouterModule } from '@angular/router';
import { DashboardComponent } from './dashboard/dashboard.component';
import { OrganisationComponent } from './organisation/organisation.component';
import { TopNavbarComponent } from './top-navbar/top-navbar.component';
import { VendorComponent } from './vendor/vendor.component';
import { RolesComponent } from './roles/roles.component';
import { CreateTicketComponent } from './create-ticket/create-ticket.component';
import { ViewTicketComponent } from './view-ticket/view-ticket.component';
import { ModuleComponent } from './module/module.component';
import { UrlCreationComponent } from './url-creation/url-creation.component';
import { ClientComponent } from './client/client.component';
import { UsercreationComponent } from './usercreation/usercreation.component';
import { UserroleComponent } from './userrole/userrole.component';
import { ModuleClientComponent } from './module-client/module-client.component';
import { UrlMappingComponent } from './url-mapping/url-mapping.component';
import { RoleUserComponent } from './role-user/role-user.component';
import { ModuleRoleComponent } from './module-role/module-role.component';
import { RoleActionComponent } from './role-action/role-action.component';
import { AdminUserComponent } from './admin-user/admin-user.component';
import { AuthGuardService } from './auth-guard.service';
import { AdminAuthComponent } from './admin-auth/admin-auth.component';
import { ModuleUserRoleComponent } from './module-user-role/module-user-role.component';
import { NavbarComponent } from './navbar/navbar.component';
import { VendorUserComponent } from './vendor-user/vendor-user.component';
import { SupportGroupComponent } from './support-group/support-group.component';
import { VendorSupportComponent } from './vendor-support/vendor-support.component';
import { RoleUserActionComponent } from './role-user-action/role-user-action.component';
import { TicketPropertyComponent } from './ticket-property/ticket-property.component';
import { ProcessAreaComponent } from './process-area/process-area.component';
import { MenusComponent } from './menus/menus.component';
import { CategoryComponent } from './category/category.component';
import { MenuUrlComponent } from './menu-url/menu-url.component';
import { CategoryGroupComponent } from './category-group/category-group.component';
import { ImpactComponent } from './impact/impact.component';
import { UrgencyComponent } from './urgency/urgency.component';
import { PriorityComponent } from './priority/priority.component';
import { SlaComponent } from './sla/sla.component';
import { MatrixComponent } from './matrix/matrix.component';
import { MetadataTableComponent } from './metadata-table/metadata-table.component';
import { MetadataFieldComponent } from './metadata-field/metadata-field.component';
import { MetadataUrlComponent } from './metadata-url/metadata-url.component';
import { MetadataUserTableComponent } from './metadata-user-table/metadata-user-table.component';
import { MetadataUserFieldComponent } from './metadata-user-field/metadata-user-field.component';
import { WorkflowComponent } from './workflow/workflow.component';
import { FlowComponentComponent } from './flow-component/flow-component.component';
import { FlowComponentDetailsComponent } from './flow-component-details/flow-component-details.component';
import { FlowClientComponent } from './flow-client/flow-client.component';
import { ClientTicketComponent } from './client-ticket/client-ticket.component';
import { TicketTypeComponent } from './ticket-type/ticket-type.component';
import { StatusComponent } from './status/status.component';
import { ClientStatusComponent } from './client-status/client-status.component';
import { BWorkflowComponent } from './b-workflow/b-workflow.component';
import { HolidaysComponent } from './holidays/holidays.component';
import { TicketFieldsComponent } from './ticket-fields/ticket-fields.component';
import { TicketMenuComponent } from './ticket-menu/ticket-menu.component';
import { SlaClientComponent } from './sla-client/sla-client.component';
import { ReportComponent } from './report/report.component';
import { TicketConfigComponent } from './ticket-config/ticket-config.component';
import { EscalationComponent } from './escalation/escalation.component';
import { PriorityConfigComponent } from './priority-config/priority-config.component';
import { SlaConfigComponent } from './sla-config/sla-config.component';
import { ItAssetMgmtComponent } from './it-asset-mgmt/it-asset-mgmt.component';
import { ItAssetManagementColumnComponent } from './it-asset-management-column/it-asset-management-column.component';
import { ItAssetManagementValueComponent } from './it-asset-management-value/it-asset-management-value.component';
import { AssetDescriptionComponent } from './asset-description/asset-description.component';
import { AssetSearchComponent } from './asset-search/asset-search.component';
import { CreateDocuComponent } from './document/create-docu/create-docu.component';
import { ViewDocuComponent } from './document/view-docu/view-docu.component';
import { AccessSpecifiersComponent } from './document/access-specifiers/access-specifiers.component';
import { CreateTicketLTComponent } from './create-ticket-lt/create-ticket-lt.component';
import { RolesLTComponent } from './roles-lt/roles-lt.component';
import { LoginLTComponent } from './login-lt/login-lt.component';
import { TokenComponent } from './token/token.component';
import { CategoryLavelMappingComponent } from './category-lavel-mapping/category-lavel-mapping.component';
import { NavbarLtComponent } from './navbar-lt/navbar-lt.component';
import { ViewTicketLtComponent } from './view-ticket-lt/view-ticket-lt.component';
import { AddEmailTemplateComponent } from './add-email-template/add-email-template.component';
import { FollowupComponent } from './followup/followup.component';
import { EscalateComponent } from './escalate/escalate.component';
import { EscalateSupportGroupComponent } from './escalate-support-group/escalate-support-group.component';
import { FaqComponent } from './faq/faq.component';
import { FaqCategoryComponent } from './faq-category/faq-category.component';
import { FaqMasterComponent } from './faq-master/faq-master.component';
import { SearchComponent } from './search/search.component';
import { ClientSpecificUrlComponent } from './client-specific-url/client-specific-url.component';
import { CreateTicketCitComponent } from './create-ticket-cit/create-ticket-cit.component';
import { ReportSscComponent } from './report-ssc/report-ssc.component';
import { ClientFuncComponent } from './client-func/client-func.component';
import { TempSscReportComponent } from './temp-ssc-report/temp-ssc-report.component';
import { DashboardCitComponent } from './dashboard-cit/dashboard-cit.component';
import { CheckListComponent } from './check-list/check-list.component';
import { EscalatMasterComponent } from './escalat-master/escalat-master.component';
import { CsatMasterComponent } from './csat-master/csat-master.component';
import { CsatQuestionComponent } from './csat-question/csat-question.component';
import { ViewTicketCitComponent } from './view-ticket-cit/view-ticket-cit.component';
import { AutoTicketMasterComponent } from './auto-ticket-master/auto-ticket-master.component';
import { SearchCitComponent } from './search-cit/search-cit.component';
import { AssetReportComponent } from './asset-report/asset-report.component';
import { AssetValidationComponent } from './asset-validation/asset-validation.component';
import { DashboardChrComponent } from './dashboard-chr/dashboard-chr.component';
import { AutoClosureMasterComponent } from './auto-closure-master/auto-closure-master.component';
import { TicketMenuConfigComponent } from './ticket-menu-config/ticket-menu-config.component';
import { CreateTicketChrComponent } from './create-ticket-chr/create-ticket-chr.component';
import { ViewTicketChrComponent } from './view-ticket-chr/view-ticket-chr.component';
import { ScheduleTicketComponent } from './schedule-ticket/schedule-ticket.component';
import { SearchChrComponent } from './search-chr/search-chr.component';
import { EmailTicketComponent } from './email-ticket/email-ticket.component';
import { TicketActivityNotificationMstComponent } from './ticket-activity-notification-mst/ticket-activity-notification-mst.component';
import { FileUploadLogsComponent } from './file-upload-logs/file-upload-logs.component';
import { EscalationWorkflowComponent } from './escalation-workflow/escalation-workflow.component';
import { ReportSscNewComponent } from './report-ssc-new/report-ssc-new.component';
import { TempSscReportNewComponent } from './temp-ssc-report-new/temp-ssc-report-new.component';
import { ReportCitComponent } from './report-cit/report-cit.component';
import { TempCitReportComponent } from './temp-cit-report/temp-cit-report.component';
import { ReportChrComponent } from './report-chr/report-chr.component';
import { TempChrReportComponent } from './temp-chr-report/temp-chr-report.component';
import { DashboardReportSlaComponent } from './dashboard-report-sla/dashboard-report-sla.component';
import { DashboardReportCsatComponent } from './dashboard-report-csat/dashboard-report-csat.component';
import { DashboardReportEscalationComponent } from './dashboard-report-escalation/dashboard-report-escalation.component';
import { DashboardReportProductivityComponent } from './dashboard-report-productivity/dashboard-report-productivity.component';
import { DashboardReportTrendComponent } from './dashboard-report-trend/dashboard-report-trend.component';
import { GroupMapCHRComponent } from './group-map-chr/group-map-chr.component';
import { DashboardReportHeatmapComponent } from './dashboard-report-heatmap/dashboard-report-heatmap.component';
import { ViewUserComponent } from './view-user/view-user.component';
import { DashboardReportTrendBarComponent } from './dashboard-report-trend-bar/dashboard-report-trend-bar.component';
import { ViewCategoryComponent } from './view-category/view-category.component';
import { TokenAppComponent } from './token-app/token-app.component';
import { DashboardCitappComponent } from './dashboard-citapp/dashboard-citapp.component';
import { CreateTicketCitAppsComponent } from './create-ticket-cit-apps/create-ticket-cit-apps.component';
import { ViewTicketCitAppsComponent } from './view-ticket-cit-apps/view-ticket-cit-apps.component';
import { SearchCitAppsComponent } from './search-cit-apps/search-cit-apps.component';
import { TicketFlowStatusComponent } from './ticket-flow-status/ticket-flow-status.component';
import { InvalidEndUserCategoriesComponent } from './invalid-end-user-categories/invalid-end-user-categories.component';
import { CategoryGroupMapComponent } from './category-group-map/category-group-map.component';
import { SupportGroupHolidaysComponent } from './support-group-holidays/support-group-holidays.component';
import { SupportGrpSlaClientComponent } from './support-grp-sla-client/support-grp-sla-client.component';
import { ReportConfiguratorComponent } from './report-configurator/report-configurator.component';
import { ReportConfiguratorViewComponent } from './report-configurator-view/report-configurator-view.component';
import { ReportCitAppsComponent } from './report-cit-apps/report-cit-apps.component';
import { TempCitAppsReportComponent } from './temp-cit-apps-report/temp-cit-apps-report.component';
import { CategorySlaMappingComponent } from './category-sla-mapping/category-sla-mapping.component';
import { FaqchrComponent } from './faqchr/faqchr.component';
import { BulkCategoryUploadComponent } from './bulk-category-upload/bulk-category-upload.component';
import { FaqDocumentUploadComponent } from './faq-document-upload/faq-document-upload.component';
import { EmailSearchComponent } from './email-search/email-search.component';
import { ActivationComponent } from './activation/activation.component';
import { SupportGroupSpecificUrlComponent } from './support-group-specific-url/support-group-specific-url.component';
import { CategoryReportComponent } from './category-report/category-report.component';
import { NotificationMasterComponent } from './notification-master/notification-master.component';
import { TileCountConfigComponent } from './tile-count-config/tile-count-config.component';
import { DashboardTcsComponent } from './dashboard-tcs/dashboard-tcs.component';
import { CreateTicketTcsComponent } from './create-ticket-tcs/create-ticket-tcs.component';
import { ViewTicketTcsComponent } from './view-ticket-tcs/view-ticket-tcs.component';
import { DisplayTicketTcsComponent } from './display-ticket-tcs/display-ticket-tcs.component';
import { TempChrReportAdminComponent } from './temp-chr-report-admin/temp-chr-report-admin.component';
import { ReportChrAdminComponent } from './report-chr-admin/report-chr-admin.component';
import { SlaViolationMasterComponent } from './sla-violation-master/sla-violation-master.component';
import { OrgsReportChrComponent } from './orgs-report-chr/orgs-report-chr.component';
import { OrgsTempChrReportComponent } from './orgs-temp-chr-report/orgs-temp-chr-report.component';
import { HybridReportCitComponent } from './hybrid-report-cit/hybrid-report-cit.component';
import { HybridReportCitappComponent } from './hybrid-report-citapp/hybrid-report-citapp.component';
import { BraioMappingMasterComponent } from './braio-mapping-master/braio-mapping-master.component';
import { BulkUserCreationComponent } from './bulk-user-creation/bulk-user-creation.component';
import { CategoryClientModuleComponent } from './category-client-module/category-client-module.component';
import { CategoryClientModuleNewComponent } from './category-client-module-new/category-client-module-new.component';
import { SupportUserModifiedComponent } from './support-user-modified/support-user-modified.component';
import { SupportUserComponent } from './support-user/support-user.component';
import { TicketMenumodifiedComponent } from './ticket-menu-modified/ticket-menu-modified.component';
import { AddEmailTemplateModifiedComponent } from './add-email-template-modified/add-email-template-modified.component';
import { HybridReportOptimizedCitappComponent } from './hybrid-optimized-report-citapp/hybrid-optimized-report-citapp.component';
import { AutoTicketMasterSSCComponent } from './auto-ticket-master-ssc/auto-ticket-master-ssc.component';
import { EmailAttrbuteMasterComponent } from './email-attribute-master/email-attribute-master.component';
import { DashboardJuscoComponent } from './dashboard-jusco/dashboard-jusco.component';
import { ViewTicketJUSCOComponent } from './view-ticket-jusco/view-ticket-jusco.component';
import { SearchJuscoComponent } from './search-jusco/search-jusco.component';
import { enduserApproverMasterScreenComponent } from './enduser_approver_master_screen/enduser_approver_master_screen.component';
import { CreateTicketJuscoComponent } from './create-ticket-jusco/create-ticket-jusco.component';
import { TicketSearchComponent } from './ticket-search/ticket-search.component';
import { LoginJUSCOComponent } from './login-jusco/login-jusco.component';
import { AutoTicketsToReportGenerationComponent } from './auto_tickets_to_report_generation/auto_tickets_to_report_generation.component';
import { CreateTicketLTSAPComponent } from './create-ticket-ltsap/create-ticket-ltsap.component';
import { ViewTicketLTSAPComponent } from './view-ticket-ltsap/view-ticket-ltsap.component';
import { DashboardLTSAPComponent } from './dashboard-ltsap/dashboard-ltsap.component';
import { SearchLTSAPComponent } from './search-ltsap/search-ltsap.component';
// import { BulkassignmentComponent } from './bulkassignment/bulkassignment.component';

import { BulkassignmentComponent } from './bulkassignment/bulkassignment.component';
import { ReAssignmentComponent } from './re-assignment/re-assignment.component';


const routes: Routes = [{
    path: '',
    component: LoginLTComponent
    //component : LoginJUSCOComponent
}, {
    path: 'testIFIX',
    component: TokenComponent
}, {
    path: 'testAPP',
    component: TokenAppComponent
}, {
    path: 'JUSCO',
    component: LoginJUSCOComponent
}, {
    path: 'activation',
    component: ActivationComponent
},
{
    path: 'admin',
    component: TopNavbarComponent,
    canActivate: [AuthGuardService],
    canActivateChild: [AuthGuardService],
    children: [
        {
            path: 'roles',
            component: RolesComponent
        }, {
            path: 'module',
            component: ModuleComponent
        }, {
            path: 'urlCreation',
            component: UrlCreationComponent
        }, {
            path: 'client',
            component: ClientComponent
            // component: TileCountConfigComponent
        }, {
            path: 'user',
            component: UsercreationComponent
        }, {
            path: 'userRoleMap',
            component: UserroleComponent
        }, {
            path: 'moduleClient',
            component: ModuleClientComponent
        }, {
            path: 'urlMapping',
            component: UrlMappingComponent
        }, {
            path: 'roleUserMap',
            component: RoleUserComponent
        }, {
            path: 'roleModuleMap',
            component: ModuleRoleComponent
        }, {
            path: 'roleAction',
            component: RoleActionComponent
        }, {
            path: 'adminUser',
            component: AdminUserComponent
        }, {
            path: 'adminUserAuth',
            component: AdminAuthComponent
        }, {
            path: 'moduleUserRole',
            component: ModuleUserRoleComponent
        }, {
            path: 'roleUserAction',
            component: RoleUserActionComponent
        }, {
            path: 'ticketProperty',
            component: TicketPropertyComponent
        }, {
            path: 'menus',
            component: MenusComponent
        }, {
            path: 'menuUrl',
            component: MenuUrlComponent
        }, {
            path: 'metaTable',
            component: MetadataTableComponent
        }, {
            path: 'metaTableField',
            component: MetadataFieldComponent
        }, {
            path: 'metaUrl',
            component: MetadataUrlComponent
        }, {
            path: 'metaTableUser',
            component: MetadataUserTableComponent
        }, {
            path: 'metaTableFieldUser',
            component: MetadataUserFieldComponent
        }, {
            path: 'workflow',
            component: WorkflowComponent
        }, {
            path: 'workflowComponent',
            component: FlowComponentComponent
        }, {
            path: 'componentDetails',
            component: FlowComponentDetailsComponent
        }, {
            path: 'clientTicketType',
            component: ClientTicketComponent
        }, {
            path: 'ticketType',
            component: TicketTypeComponent
        }, {
            path: 'status',
            component: StatusComponent
        }, {
            path: 'clientStatus',
            component: ClientStatusComponent
        }, {
            path: 'clientSpecificUrl',
            component: ClientSpecificUrlComponent
        }, {
            path: 'functionalityDetails',
            component: ClientFuncComponent
        }, {
            path: 'ticketMenuConfig',
            component: TicketMenuConfigComponent
        }, {
            path: 'tileCountConfig',
            component: TileCountConfigComponent
        }

    ]
},

{
    path: 'user',
    component: NavbarComponent,
    canActivate: [AuthGuardService],
    canActivateChild: [AuthGuardService],
    children: [
        {
            path: 'braioMapping',
            component: BraioMappingMasterComponent
        },
        {
            path: 'reportDashboardHeatmap',
            component: DashboardReportHeatmapComponent
        },
        {
            path: 'dashboard',
            component: DashboardComponent
        },
        {
            path: 'organisation',
            component: OrganisationComponent
        }, {
            path: 'vendor',
            component: VendorComponent
        }, {
            path: 'user',
            component: AdminUserComponent
        }, {
            path: 'roles',
            component: RolesComponent
        }, {
            path: 'roleUserMap',
            component: RoleUserComponent
        }, {
            path: 'vendorUserMap',
            component: VendorUserComponent
        }, {
            path: 'supportGroup',
            component: SupportGroupComponent
        }, {
            path: 'autoTicket',
            component: AutoTicketMasterComponent
        }, {
            path: 'vendorSupportGroup',
            component: VendorSupportComponent
        }, {
            path: 'userSupportGroup',
            component: SupportUserComponent
        }, {
            path: 'userSupportGroupModified',
            component: SupportUserModifiedComponent
        }, {
            path: 'processArea',
            component: ProcessAreaComponent
        }, {
            path: 'category',
            component: CategoryComponent
        }, {
            path: 'categoryClientModule',
            component: CategoryClientModuleComponent
        }, {
            path: 'categoryClientModuleNew',
            component: CategoryClientModuleNewComponent
        }, {
            path: 'roleAction',
            component: RoleActionComponent
        }, {
            path: 'roleUserAction',
            component: RoleUserActionComponent
        }, {
            path: 'categoryGroup',
            component: CategoryGroupMapComponent
        }, {
            path: 'categoryGroupMap',
            component: CategoryGroupComponent
        }, {
            path: 'impact',
            component: ImpactComponent
        }, {
            path: 'urgency',
            component: UrgencyComponent
        }, {
            path: 'priority',
            component: PriorityComponent
        }, {
            path: 'sla',
            component: SlaComponent
        }, {
            path: 'matrix',
            component: MatrixComponent
        }, {
            path: 'createTicket',
            component: CreateTicketComponent
        }, {
            path: 'viewTicket',
            component: ViewTicketComponent
        }, {
            path: 'workflowClient',
            component: FlowClientComponent
        }, {
            path: 'backwardWorkflow',
            component: BWorkflowComponent
        }, {
            path: 'holidays',
            component: HolidaysComponent
        }, {
            path: 'fields',
            component: TicketFieldsComponent
        }, {
            path: 'TicketMenumodified',
            component: TicketMenumodifiedComponent
        }, {
            path: 'ticketMenu',
            component: TicketMenuComponent
        }, {
            path: 'status',
            component: StatusComponent
        }, {
            path: 'slaClient',
            component: SlaClientComponent
        }, {
            path: 'report',
            component: ReportComponent
        }, {
            path: 'moduleRole',
            component: ModuleRoleComponent
        }, {
            path: 'ticketConfig',
            component: TicketConfigComponent
        }, {
            path: 'escalation',
            component: EscalationComponent
        }, {
            path: 'priorityConfig',
            component: PriorityConfigComponent
        }, {
            path: 'moduleUserRole',
            component: ModuleUserRoleComponent
        }, {
            path: 'slaConfig',
            component: SlaConfigComponent
        }, {
            path: 'assetMgmnt',
            component: ItAssetMgmtComponent
        }, {
            path: 'assetMgmntColumn',
            component: ItAssetManagementColumnComponent
        }, {
            path: 'assetMgmntValue',
            component: ItAssetManagementValueComponent
        }, {
            path: 'assetDesc',
            component: AssetDescriptionComponent
        }, {
            path: 'assetModification',
            component: AssetSearchComponent
        }, {
            path: 'createDocument',
            component: CreateDocuComponent
        }, {
            path: 'viewDocument',
            component: ViewDocuComponent
        }, {
            path: 'accessControls',
            component: AccessSpecifiersComponent
        }, {
            path: 'roleL&T',
            component: RolesLTComponent
        }, {
            path: 'categoryLevelMapping',
            component: CategoryLavelMappingComponent
        }, {
            path: 'addEmailTemplate',
            component: AddEmailTemplateComponent
        }, {
            path: 'addEmailTemplateModified',
            component: AddEmailTemplateModifiedComponent
        }, {
            path: 'followup',
            component: FollowupComponent
        }, {
            path: 'escalate',
            component: EscalateComponent
        }, {
            path: 'escalateToSupportGroup',
            component: EscalateSupportGroupComponent
        }, {
            path: 'faqCategory',
            component: FaqCategoryComponent
        }, {
            path: 'faqMaster',
            component: FaqMasterComponent
        }, {
            path: 'checkList',
            component: CheckListComponent
        }, {
            path: 'escalatMaster',
            component: EscalatMasterComponent
        }, {
            path: 'csat',
            component: CsatMasterComponent
        }, {
            path: 'csatQuestion',
            component: CsatQuestionComponent
        }, {
            path: 'assetReport',
            component: AssetReportComponent
        }, {
            path: 'assetValidation',
            component: AssetValidationComponent
        }, {
            path: 'autoClosureMaster',
            component: AutoClosureMasterComponent
        }, {
            path: 'emailTicketConfig',
            component: EmailTicketComponent
        }, {
            path: 'activityNotificationMst',
            component: TicketActivityNotificationMstComponent
        }, {
            path: 'fileUploadLogs',
            component: FileUploadLogsComponent
        }, {
            path: 'escalationWorkflow',
            component: EscalationWorkflowComponent
        }, {
            path: 'reportDashboardSla',
            component: DashboardReportSlaComponent
        }, {
            path: 'reportDashboardCsat',
            component: DashboardReportCsatComponent
        }, {
            path: 'reportDashboardEscalation',
            component: DashboardReportEscalationComponent
        }, {
            path: 'reportDashboardProductivity',
            component: DashboardReportProductivityComponent
        }, {
            path: 'reportDashboardTrend',
            component: DashboardReportTrendComponent
        }, {
            path: 'viewUser',
            component: ViewUserComponent
        }, {
            path: 'reportDashboardTrendBar',
            component: DashboardReportTrendBarComponent
        }, {
            path: 'viewCategory',
            component: ViewCategoryComponent
        }, {
            path: 'ticketStatuFlow',
            component: TicketFlowStatusComponent
        }, {
            path: 'invalidChrEnduser',
            component: InvalidEndUserCategoriesComponent
        }, {
            path: 'reportConfigurator',
            component: ReportConfiguratorComponent
        }, {
            path: 'reportConfiguratorView',
            component: ReportConfiguratorViewComponent
        }, {
            path: 'SupportGroupHolidays',
            component: SupportGroupHolidaysComponent
        }, {
            path: 'SupportGroupSlaClient',
            component: SupportGrpSlaClientComponent
        }, {
            path: 'categoryGroupMap',
            component: CategoryGroupComponent
        }, {
            path: 'categorySlaMapping',
            component: CategorySlaMappingComponent
        }, {
            path: 'bulkCategory',
            component: BulkCategoryUploadComponent
        }, {
            path: 'faqDocumentUpload',
            component: FaqDocumentUploadComponent
        }, {
            path: 'supportGroupSpecificUrl',
            component: SupportGroupSpecificUrlComponent
        }, {
            path: 'categoryReport',
            component: CategoryReportComponent
        }, {
            path: 'notificationMaster',
            component: NotificationMasterComponent
        }, {
            path: 'tempChrReportAdmin',
            component: TempChrReportAdminComponent
        }, {
            path: 'reportChrAdmin',
            component: ReportChrAdminComponent
        }, {
            path: 'slaViolationMaster',
            component: SlaViolationMasterComponent
        }, {
            path: 'userBulkUpload',
            component: BulkUserCreationComponent
        }, {
            path: 'faqUpload',
            component: FaqDocumentUploadComponent
        }, {
            path: 'autoTicketSSC',
            component: AutoTicketMasterSSCComponent
        }, {
            path: 'EmailAttrbuteMaster',
            component: EmailAttrbuteMasterComponent
        }, {
            path: 'enduserApproverMasterScreen',
            component: enduserApproverMasterScreenComponent
        }
    ]
}, {
    path: 'ticket',
    component: NavbarLtComponent,
    children: [
        {
            path: 'dashboard',
            component: DashboardComponent
        }, {
            path: 'createTicketL&T',
            component: CreateTicketLTComponent
        }, {
            path: 'viewTicketL&TSSC',
            component: ViewTicketLtComponent
        }, {
            path: 'viewTicketL&TCIT',
            component: ViewTicketCitComponent
        }, {
            path: 'faq',
            component: FaqComponent
        }, {
            path: 'search',
            component: SearchComponent
        }, {
            path: 'createTicketCIT',
            component: CreateTicketCitComponent
        }, {
            path: 'reportSsc',
            component: ReportSscComponent
        }, {
            path: 'tempSscReport',
            component: TempSscReportComponent
        }, {
            path: 'DashboardCIT',
            component: DashboardCitComponent
        }, {
            path: 'searchCIT',
            component: SearchCitComponent
        }, {
            path: 'dashboardLnTCHR',
            component: DashboardChrComponent
        }, {
            path: 'createTicketCHR',
            component: CreateTicketChrComponent
        }, {
            path: 'viewTicketL&TCHR',
            component: ViewTicketChrComponent
        }, {
            path: 'autoTicket',
            component: ScheduleTicketComponent
        }, {
            path: 'searchCHR',
            component: SearchChrComponent
        }, {
            path: 'reportSscNew',
            component: ReportSscNewComponent
        }, {
            path: 'tempSscReportNew',
            component: TempSscReportNewComponent
        }, {
            path: 'reportCitM',
            component: ReportCitComponent
        }, {
            path: 'reportCitS',
            component: TempCitReportComponent
        }, {
            path: 'reportChrM',
            component: ReportChrComponent
        }, {
            path: 'reportChrS',
            component: TempChrReportComponent
        }, {
            path: 'groupMap',
            component: GroupMapCHRComponent
        }, {
            path: 'dashboardL&TCITAPP',
            component: DashboardCitappComponent
        }, {
            path: 'createTicketL&TCITAPP',
            component: CreateTicketCitAppsComponent
        }, {
            path: 'viewTicketL&TCITAPP',
            component: ViewTicketCitAppsComponent
        }, {
            path: 'searchL&TCITAPP',
            component: SearchCitAppsComponent
        }, {
            path: 'reportCitAppsM',
            component: ReportCitAppsComponent
        }, {
            path: 'reportCitAppsS',
            component: TempCitAppsReportComponent
        }, {
            path: 'faqChr',
            component: FaqchrComponent
        }, {
            path: 'emailSearch',
            component: EmailSearchComponent
        }, {
            path: 'dashboardTCS',
            component: DashboardTcsComponent
        }, {
            path: 'createTicketTCS',
            component: CreateTicketTcsComponent
        }, {
            path: 'viewTicketTCS',
            component: ViewTicketTcsComponent
        }, {
            path: 'displayTicketTCS',
            component: DisplayTicketTcsComponent
        }, {
            path: 'faqTcs',
            component: FaqchrComponent
        }, {
            path: 'orgsReportChrM',
            component: OrgsReportChrComponent
        }, {
            path: 'orgsReportChrS',
            component: OrgsTempChrReportComponent
        }, {
            path: 'reporCitH',
            component: HybridReportCitComponent
        }, {
            path: 'reporCitAppsH',
            component: HybridReportCitappComponent
        }, {
            path: 'reporCitAppsHybridOTMZ',
            component: HybridReportOptimizedCitappComponent
        }, {
            path: 'DashboardJusco',
            component: DashboardJuscoComponent
        }, {
            path: 'ViewTicketJusco',
            component: ViewTicketJUSCOComponent
        }, {
            path: 'SearchJusco',
            component: SearchJuscoComponent
        }, {
            path: 'CreateTicketJusco',
            component: CreateTicketJuscoComponent
        }, {
            path: 'TicketSearch',
            component: TicketSearchComponent
        }, {
            path: 'autoTicketsToReportGeneration',
            component: AutoTicketsToReportGenerationComponent
        }, {
            path: 'CreateTicketLTSAP',
            component: CreateTicketLTSAPComponent
        }, {
            path: 'ViewTicketLTSAP',
            component: ViewTicketLTSAPComponent
        }, {
            path: 'DashboardLTSAP',
            component: DashboardLTSAPComponent
        }, {
            path: 'SearchLTSAP',
            component: SearchLTSAPComponent
        },
        {
            path: 'bulkAssigment',
            component: BulkassignmentComponent
        },
        {
            path: 'ReAssigment',
            component: ReAssignmentComponent
        }
    ]
}
];

@NgModule({
    imports: [RouterModule.forRoot(routes)],
    exports: [RouterModule]
})
export class AppRoutingModule {
}
